import { useTranslation } from 'next-i18next/pages'
import styles from './Careers.module.scss'
import classNames from 'classnames'
import type { CareersPageProps } from './types'
import NextLink from 'next/link'
import { routes } from 'utils/routes'
import { CallToAction, Heading, TextAndMedia, Icon, BREAKPOINTS } from '@boltenergy-be/design-system'
import Link from 'components/link/Link'
import heroImage from 'public/images/career-page-hero.webp'
import HeroImage from 'components/hero-image/HeroImage'
import { useGetLanguage } from 'hooks/useGetLanguage'

export const Careers = ({ jobOffers }: CareersPageProps) => {
  // i18n
  const { t } = useTranslation('careers')
  const language = useGetLanguage()

  return (
    <main className={styles.careers}>
      {/* HERO IMAGE */}
      <section data-color="dark" className={classNames('section', styles.hero)}>
        <HeroImage src={heroImage} alt="Team Bolt Energie" sizes={`(max-width: ${BREAKPOINTS.tablet}px) 125vw`} />
      </section>

      {/* CAREERS */}
      <section className={classNames('section', 'is-dark', styles['jobs-wrapper'])}>
        <div className="container">
          <Heading as="h1" variant="d3" className="mb-500">
            {t('title', 'Vacatures bij Bolt')}
          </Heading>
          <ul className={styles.jobs}>
            {jobOffers?.length ? (
              jobOffers.map((job, idx) => (
                <li key={`job-${idx}`}>
                  <NextLink href={routes(language, job.slug).careerDetail} className={styles.job}>
                    <span>{job.title}</span>
                    <Icon name="chevronRight" />
                  </NextLink>
                </li>
              ))
            ) : (
              <li className={classNames(styles.job, styles['empty-state'])}>
                {t('noneFound', 'Kom binnenkort nog eens kijken, er zijn momenteel geen vacatures te bespeuren.')}
              </li>
            )}
          </ul>
        </div>
      </section>

      <CallToAction
        title={t('noVacanciesForYourProfile.title')}
        color="accent-soft"
        shape="s2"
        shapeClassName={styles.shape}
        action={
          <Link
            representation="button"
            href={`mailto:talent@boltenergie.be?subject=${t('noVacanciesForYourProfile.openApplication')}`}
            variant="layered"
            trailingIcon="chevronRight"
          >
            {t('noVacanciesForYourProfile.action')}
          </Link>
        }
      >
        <p>{t('noVacanciesForYourProfile.description')}</p>
      </CallToAction>

      <TextAndMedia
        title={t('changeMarket.title')}
        media={{
          type: 'image',
          props: {
            publicId: 'website/common/paulien-lotte',
            fill: true,
            alt: 'Paulien en Lotte'
          }
        }}
      >
        <p>{t('changeMarket.description')}</p>
      </TextAndMedia>
    </main>
  )
}

export default Careers
